module.exports = __webpack_public_path__ + "static/media/aquarius-logo.64650adc.svg";